import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: theme.colors.alertsInfoBg,
    borderRadius: 8,
    display: 'grid',
    alignItems: 'center',
    position: 'relative',

    max768: {
        gap: theme.spacing(16),
        padding: theme.spacing(16),
    },

    min768: {
        gap: theme.spacing(24),
        padding: theme.spacing(24),

        gridTemplateColumns: 'minmax(auto, 220px) 1fr',
    },
});

export const banner: TRuleWithTheme = ({ theme }) => ({
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    maxWidth: 220,
});

export const title: TRuleWithTheme = ({ theme }) => ({
    marginBottom: theme.spacing(16),
    ...theme.typography.Headline3,
});

export const text: TRuleWithTheme = ({ theme }) => ({
    ...theme.typography.ParagraphSmallMedium,
    marginBottom: theme.spacing(8),
});

export const button: TRuleWithTheme = ({ theme }) => ({
    marginTop: theme.spacing(16),
});

export const closeButton: TRuleWithTheme = ({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(16),
    right: theme.spacing(16),
    color: theme.colors.black,

    '& svg': {
        fill: theme.colors.black,
    },

    '&:hover svg': {
        fill: theme.colors.accentPrimary,
    },
});
